var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.usersWithName,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        scopedSlots: _vm._u(
          [
            {
              key: "table-row",
              fn: function(props) {
                return [
                  props.column.field === "actions"
                    ? _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "div",
                          { staticClass: "btn-group" },
                          [
                            _vm._t("userButtonsBefore", null, {
                              groupUser: props.row.groupUser
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-danger",
                                on: {
                                  click: function($event) {
                                    return _vm.onRemoveUser(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash" })]
                            ),
                            _vm._v(" "),
                            _vm._t("userButtonsAfter", null, {
                              groupUser: props.row.groupUser
                            })
                          ],
                          2
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(props.formattedRow[props.column.field]) +
                            "\n      "
                        )
                      ])
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success mt-2",
          attrs: { title: _vm.$t("btnAdd") },
          on: { click: _vm.openSelectModal }
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      ),
      _vm._v(" "),
      _c("UsersSelectModal", {
        ref: "selectModal",
        attrs: { allUsers: _vm.allUsersForSelectModal },
        on: { selected: _vm.onUsersSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }